export function videoHover() {
    const itemWithVideo = $(".has-video");

    itemWithVideo.each(function () {
        const video = $(this);
        if (!video.parents(".article").length) {
            video.on("mouseover", function () {
                if (video.find("video")) {
                    video.find("video")[0].play();
                }
            }).on("mouseleave", function () {
                if (video.find("video")) {
                    video.find("video")[0].pause();
                }
            });
        } else {
            video.on("click", function () {
                video.addClass("playing");
            });
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoHover.js